export default {

  props: {
    eventBus: Object
  },

  computed: {

    // Toolbar helpers

    isRootSection () {
      return this.level === 0
    },

    displayRemove () {
      return !this.isRootSection
    },

    toolbarEnabled () {
      return this.$store.getters['checklist/isFilled'] === false
    },

    displayActions () {
      return this.index > 0
    },

    // Tree helpers

    nextLevel () {
      return this.level + 1
    },

    nextIdx () {
      return this.$store.getters['checklist/nextIdx']
    },

    // Copy + Cut / Paste

    actionClass () {
      return {
        'ghost': this.inCut,
        'drag': this.inCopy,
        'pb-2': (/input/).test(this.$options.name)
      }
    },

    displayPaste () {
      const actionIndex = this.$store.getters['checklist/copyIdx'] || this.$store.getters['checklist/cutIdx']
      return actionIndex !== null && actionIndex !== this.index
    },

    inCopy () {
      return this.$store.getters['checklist/inCopy'](this.index)
    },

    inCut () {
      return this.$store.getters['checklist/inCut'](this.index)
    },

    copyTitle () {
      return this.inCopy ? this.$t('cancel') : this.$t('copy')
    },

    cutTitle () {
      return this.inCut ? this.$t('cancel') : this.$t('cut')
    },

    // Sort / Reorder

    sortedItems: {
      get () {
        return this.items
      },
      set (items) {
        this.eventBus.$emit('update', {
          idx: this.index,
          items
        })
      }
    },

    // Translations

    selectedLanguage () {
      return this.$store.getters['checklist/language']
    },

    translatedLabel () {
      return `${this.$t('label')} (${this.selectedLanguage})`
    },

    translatedDescription () {
      return `${this.$t('description')} (${this.selectedLanguage})`
    },

    // Common props

    localLabel: {
      get: function () {
        return this.label
      },
      set: function (val) {
        this.eventBus.$emit('update', {
          idx: this.index,
          label: val || null
        })
      }
    },

    localTranslatedLabel: {
      get: function () {
        const { selectedLanguage, translation } = this
        return translation && translation[selectedLanguage] ? translation[selectedLanguage].label : null
      },
      set: function (value) {
        const { selectedLanguage, translation } = this
        const updatedTranslation = Object.assign({}, translation, {
          [selectedLanguage]: {
            label: value,
            description: translation[selectedLanguage] ? translation[selectedLanguage].description : null
          }
        })
        this.eventBus.$emit('update', {
          idx: this.index,
          translation: updatedTranslation
        })
      }
    },

    localDescription: {
      get: function () {
        return this.description
      },
      set: function (val) {
        this.eventBus.$emit('update', {
          idx: this.index,
          description: val || null
        })
      }
    },

    localTranslatedDescription: {
      get: function () {
        const { selectedLanguage, translation } = this
        return translation && translation[selectedLanguage] ? translation[selectedLanguage].description : null
      },
      set: function (value) {
        const { selectedLanguage, translation } = this
        const updatedTranslation = Object.assign({}, translation, {
          [selectedLanguage]: {
            description: value,
            label: translation[selectedLanguage] ? translation[selectedLanguage].label : null
          }
        })
        this.eventBus.$emit('update', {
          idx: this.index,
          translation: updatedTranslation
        })
      }
    },

    // Variable source

    localSource: {
      get: function () {
        return this.source.name
      },
      set: function (name) {
        const variable = this.sourceVariables.filter(v => v.name === name).shift()
        const source = variable ? { ...variable, unit: null, displayUnit: null } : null
        this.$nextTick(() => {
          this.eventBus.$emit('update', {
            idx: this.index,
            source
          })
        })
      }
    }
  },

  methods: {

    // Copy + Cut / Paste

    paste () {
      this.$store.dispatch('checklist/paste', { idx: this.index })
    },

    copy () {
      this.inCopy
        ? this.$store.dispatch('checklist/copy', { idx: null })
        : this.$store.dispatch('checklist/copy', { idx: this.index })
    },

    cut () {
      this.inCut
        ? this.$store.dispatch('checklist/cut', { idx: null })
        : this.$store.dispatch('checklist/cut', { idx: this.index })
    },

    // Remove item (self)
    remove () {
      this.eventBus.$emit('remove', { idx: this.index })
    }
  }
}
